export default __webpack_public_path__ + "static/media/promos.07d1dddc.svg";